<template>
  <div
    v-if="contentCards && contentCards.length > 0"
    :data-entry-id="id"
    class="swa-content-banner-container section"
  >
    <div class="container">
      <UiContentCard
        v-for="(card, index) in contentCards"
        :key="card.id"
        v-element-visibility="[
          (visible: boolean) =>
            visible && onTrackEvent('impression', card.internalName, index),
          {
            threshold: 1,
          },
        ]"
        :data-entry-id="card.id"
        v-bind="card"
        class="content-card-width"
        @click="onContentClicked(card.internalName, index)"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import UiContentCard from '@sephora-asia/ui-content-card'
import { vElementVisibility } from '@vueuse/components'
import type { ContentBannerContainerProps } from '~/types/components/contentful/components.types'
import { usePageMetaStore } from '~/stores/page-meta-store'

const props = defineProps<ContentBannerContainerProps>()
const { trackEvent } = useGtmTrack()
const pageMetaStore = usePageMetaStore() // Destructuring from store breaks top-lvl refs

function onTrackEvent(eventType: string, internalName: string, index: number) {
  trackEvent({
    event: `${pageMetaStore.pageType}_content_banner_${eventType}`,
    params: {
      banner_name: internalName,
      banner_position: index + 1,
      content_banner_position: props.componentPosition,
      campaign_name: pageMetaStore.campaignName,
      page_path: useRoute().path,
      segmented: props.contentCards[index]?.isSegmented,
      segments: props.contentCards[index]?.segments?.join(', '),
    },
  })
}

function onContentClicked(internalName: string, index: number) {
  onTrackEvent('click', internalName, index)
}

const numberOfCols = computed(() => props.contentCards.length)
</script>

<style lang="scss" scoped>
.swa-content-banner-container .container {
  --cols: v-bind(numberOfCols);

  width: 100%;
  display: grid;
  gap: 24px;
  grid-template-columns: repeat(var(--cols), minmax(0, 1fr));

  .content-card-width {
    min-width: 100%; // For truncating text in child elements preventing overflow

    @include mobile {
      display: flex;
    }
  }

  @include mobile {
    grid-template-columns: 1fr;
  }

  :deep(.content-card-link) {
    width: 100%;
  }
}
</style>
